import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/institution/didiAlarm/group/list',
    name: 'InstitutionDidiAlarmGroupList',
    component: () => import('@/views/institution/didiAlarm/group/list/index'),
    meta: {
      title: i18n.t('router.didiAlarm.group_manage'),
      headType: 2, // 企业头部
      routerType: 2, // 企业路由
      auth: true
    }
  },
  {
    path: '/admin/institution/didiAlarm/alarm/list',
    name: 'InstitutionDidiAlarmList',
    component: () => import('@/views/institution/didiAlarm/alarm/list/index'),
    meta: {
      title: i18n.t('router.didiAlarm.call_record_list'),
      headType: 2, // 企业头部
      routerType: 2, // 企业路由
      auth: true
    }
  },
  {
    path: '/admin/institution/didiAlarm/alarm/detail',
    name: 'InstitutionDidiAlarmDetail',
    component: () => import('@/views/institution/didiAlarm/alarm/detail/index'),
    meta: {
      title: i18n.t('router.didiAlarm.call_record_detail'),
      headType: 2, // 企业头部
      routerType: 2, // 企业路由
      auth: true
    }
  },
  {
    path: '/admin/institution/didiAlarm/receiver/list',
    name: 'InstitutionDidiAlarmReceiverList',
    component: () => import('@/views/institution/didiAlarm/receiver/list/index'),
    meta: {
      title: i18n.t('router.didiAlarm.receiver_manage'),
      headType: 2, // 企业头部
      routerType: 2, // 企业路由
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/institution/didiAlarm.js